import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isCodingSessionUri } from '@spotify/plugin-confidence-artifacts-react';

export type CodingSessionRef = {
  provider: string;
  sessionId: string;
};

const CODING_SESSION_URL_LABEL = 'coding_session_url';
const CODING_SESSION_CHILD_CHAT_LABEL = 'coding_session_child_chat';
const CODING_SESSION_PARENT_CHAT_LABEL = 'coding_session_parent_chat';

const getLabel = (
  artifact: AttachmentFragment,
  key: string,
): string | undefined =>
  artifact.labels.find(label => label.key === key)?.value ?? undefined;

export const getCodingSessionRef = (
  uri: string,
): CodingSessionRef | undefined => {
  if (isCodingSessionUri(uri)) {
    const [, provider, sessionId] = uri.replace(/^\/\//, '').split('/');
    return { provider, sessionId };
  }

  try {
    const { hostname, pathname } = new URL(uri);
    const cursorMatch = pathname.match(/^\/agents\/([^/]+)$/);
    if (['cursor.com', 'www.cursor.com'].includes(hostname) && cursorMatch) {
      return { provider: 'cursor', sessionId: cursorMatch[1] };
    }
  } catch {
    return undefined;
  }

  return undefined;
};

export const isCodingSessionArtifact = (
  artifact: AttachmentFragment,
): boolean => getCodingSessionRef(artifact.uri) !== undefined;

export const getCodingSessionUrl = (
  artifact: AttachmentFragment,
): string | undefined =>
  getLabel(artifact, CODING_SESSION_URL_LABEL) ??
  (artifact.uri.startsWith('https://') || artifact.uri.startsWith('http://')
    ? artifact.uri
    : undefined);

export const getCodingSessionChildChat = (
  artifact: AttachmentFragment,
): string | undefined => getLabel(artifact, CODING_SESSION_CHILD_CHAT_LABEL);

export const getCodingSessionParentChat = (
  artifact: AttachmentFragment,
): string | undefined => getLabel(artifact, CODING_SESSION_PARENT_CHAT_LABEL);
